export default __webpack_public_path__ + "static/media/photo--lg--78.166d4381.jpg";